/* orders */
import OrderPageLanding from "../../../app-module-order-page-landing_05";
import OrderPageList from "../../../app-module-order-page-list_05";
import OrderPageDetail from "../../../app-module-order-page-detail";

/* click-and-collect actions, in flow order */
import OrderPageApproveCollected from "../../../app-module-order-page-approve-collected";
import OrderLandingApprove from "../../../app-module-order-landing-success-approve";
import OrderPageConfirmation from "../../../app-module-order-page-confirmation";
import OrderLandingConfirmation from "../../../app-module-order-landing-success-confirmation";
import OrderPageActivationSendingCollected from "../../../app-module-order-page-activation-sending-collected";
import OrderLandingActivationSendingCollected from "../../../app-module-order-landing-success-activation-sending-collected";
import OrderPageCollect from "../../../app-module-order-page-collect";

/* decline / delete + their success pages */
import OrderPageDecline from "../../../app-module-order-page-decline";
import OrderLandingDecline from "../../../app-module-order-landing-success-decline";
import OrderPageDelete from "../../../app-module-order-page-delete";
import OrderLandingDelete from "../../../app-module-order-landing-success-delete";

/* documents */
import OrderPagePDF from "../../../app-module-order-page-pdf";
import OrderPagePDFOrderSummary from "../../../app-module-order-page-pdf-order-summary";
/* orders */

// Uses the shared app-module-order-page-detail, not detail_04: only the shared
// one renders the click-and-collect action buttons (Approve, Mark for
// Collection, Mark Collected and Activated). None of those branches require
// isHQ, so they light up for role 5.
//
// ponytail: every route reachable from that detail page is listed here, so no
// action button leads to a 404. Deliberately absent: create, edit and search -
// a store operator does not originate or amend orders, and /orders/search has
// no entry point since list_05 drops the search box.
const orderModules = [
  OrderPageLanding,
  OrderPageList,
  OrderPageDetail,
  OrderPageApproveCollected,
  OrderLandingApprove,
  OrderPageConfirmation,
  OrderLandingConfirmation,
  OrderPageActivationSendingCollected,
  OrderLandingActivationSendingCollected,
  OrderPageCollect,
  OrderPageDecline,
  OrderLandingDecline,
  OrderPageDelete,
  OrderLandingDelete,
  OrderPagePDF,
  OrderPagePDFOrderSummary,
];

const modules = {
  company: [],
  reporting: [],
  orders: orderModules,
  product: [],
};

export default modules;
